import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../../core/store/store';
import { usePanelAccess } from '../../context/PanelAccessContext';
import PanelHubGrid, { HubCardItem } from '../../components/PanelHubGrid';

const ALL_CARDS: (HubCardItem & { referentFunction?: string })[] = [
  { to: '/panel/moderation',    title: 'File moderation',     description: 'Signalements et sanctions joueurs.',                  accent: 'amber'   },
  { to: '/panel/joueurs/liste', title: 'Liste & surveillance', description: 'Joueurs en ligne, details, sanctions quotidiennes.', accent: 'sky'     },
  { to: '/panel/logs',          title: 'Logs & securite',     description: 'Synthese et logs d\'authentification.',              accent: 'emerald' },
];

const PanelModoHubV1: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useSelector((state: RootState) => state.user);
  const { loading, hasAccessToSection, hasReferentFunction } = usePanelAccess();
  const roleId = currentUser?.roles_id ?? 0;
  const canEnterHub = hasAccessToSection('salon_modo');

  useEffect(() => {
    if (!loading && currentUser && !canEnterHub) {
      navigate('/panel/dashboard', { replace: true });
    }
  }, [loading, currentUser, canEnterHub, navigate]);

  const cards = useMemo(() => {
    return ALL_CARDS.filter((c) => {
      if (c.referentFunction) {
        if (roleId === 1) return true;
        return hasReferentFunction(c.referentFunction);
      }
      return true;
    });
  }, [hasReferentFunction, roleId]);

  if (!currentUser || loading || !canEnterHub) {
    return null;
  }

  return (
    <PanelHubGrid
      description="Moderation et surveillance des joueurs. Pas d'acces premium, economie, scenarios ni outils systeme CM."
      cards={cards}
    />
  );
};

export default PanelModoHubV1;
